import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../colors-v2';

const Main = styled.span`
  display: inline;

  cursor: pointer;
  word-break: break-word;

  font-size: inherit;
  line-height: inherit;
  color: inherit;

  > * {
    outline: none;
    min-width: 84px;
    border-bottom: 2px solid ${colorsV2.gray100};
    display: inline-block;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
  }
  [contenteditable],
  .custom-content-editable-component {
    user-select: text;
  }

  [contenteditable][placeholder]:empty:before {
    content: attr(placeholder);
    position: absolute;
    color: gray;
    background-color: transparent;
  }
`;

interface SlateAutoSizeInputProps {
  value: string;
  onChange?: (newValue: string) => void;
  onChangeText?: (newValue: string) => void;
  inputProps?: any;
  onClick?: (e: any) => void;
  disabled?: boolean;
  placeholder?: string;
  onPaste?: (e: any) => void;
}

const ContentEditable = React.forwardRef((props: any, ref: any) => {
  const { value, onChange, placeholder, disabled, onChangeText, ...rest } = props;
  const [initialValue] = React.useState(value);

  const handleInput = (event) => {
    if (onChange) {
      onChange(event.target.innerHTML);
    }
    if (onChangeText) {
      onChangeText(event.target.innerText);
    }
  };

  return (
    <span
      ref={ref}
      data-slate-editor
      contentEditable={!disabled}
      onInput={handleInput}
      className="custom-content-editable-component"
      placeholder={placeholder}
      dangerouslySetInnerHTML={{ __html: initialValue }}
      {...rest}
    />
  );
});

export const SlateAutoSizeInput = React.forwardRef((props: SlateAutoSizeInputProps, ref) => {
  const { value, onChange, placeholder, onChangeText, disabled, inputProps, ...rest } = props;

  return (
    <Main className={cl('slate-auto-size-input', { focus: true, disabled })} {...rest}>
      <ContentEditable
        ref={ref}
        value={value}
        onChange={onChange}
        onChangeText={onChangeText}
        disabled={disabled}
        placeholder={placeholder}
        {...inputProps}
      />
    </Main>
  );
});
